var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2549_4034)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.246094,
    width: 55,
    height: 55,
    rx: 12,
    fill: "url(#paint0_linear_2549_4034)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6922 13.7987C45.5168 13.7806 45.3401 13.7806 45.1647 13.7987H9.14326C8.91239 13.8023 8.68306 13.8368 8.46143 13.9015L27.0511 32.4005L45.6922 13.7987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2321 15.4766L28.7521 33.9265C28.2765 34.4005 27.6331 34.6665 26.9625 34.6665C26.2919 34.6665 25.6485 34.4005 25.1729 33.9265L6.85789 15.6165C6.80159 15.824 6.77173 16.0378 6.76904 16.2527V41.701C6.76904 42.3759 7.03649 43.0232 7.51254 43.5004C7.9886 43.9777 8.63426 44.2458 9.3075 44.2458H44.846C45.5192 44.2458 46.1649 43.9777 46.6409 43.5004C47.117 43.0232 47.3844 42.3759 47.3844 41.701V16.2527C47.3743 15.9876 47.3229 15.7257 47.2321 15.4766ZM11.0464 41.701H9.28212V39.8814L18.5094 30.7073L20.299 32.5014L11.0464 41.701ZM44.8206 41.701H43.0437L33.791 32.5014L35.5806 30.7073L44.8079 39.8814L44.8206 41.701Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2549_4034",
    x1: 27.5,
    y1: 0.246094,
    x2: 27.5,
    y2: 55.2461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2172F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AC2F9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2549_4034"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.246094,
    width: 55,
    height: 55,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.e9f8922591c33039540239bdd262b8e3.svg";
export { ForwardRef as ReactComponent };